var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlob4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 548,
    viewBox: "0 0 548 526",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.5 28.4993C313.73 22.6228 416.5 -6.52471 492 1.99992C551.5 8.71805 557.5 41.5 535.5 100.5C521.699 137.512 491.291 220.526 492 273.999C492.895 341.489 558.152 422.206 525 480.999C492.537 538.57 427 527.999 364 514.999C301 501.999 227 507.999 153.5 514.999C74.8559 522.489 57.5415 502.742 24.8021 454.984C-7.33371 408.107 48.7849 314.788 46.5 257.999C44.4699 207.542 -12.5128 120.891 3.50007 72.999C20.6601 21.6762 42 13.499 101.272 8.71805C169 8.71805 199.435 33.7742 253.5 28.4993Z",
    fill: "#F3E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob4);
export default __webpack_public_path__ + "static/media/Blob4.b827aab4334f01043d3fd55ad43000da.svg";
export { ForwardRef as ReactComponent };